import { useQuery, useLazyQuery } from '@apollo/client';
import { GET_SUBSCRIPTIONS } from '@/graphql/queries';
import { GetSubscriptionsResponse } from '@/graphql/types';
import { allSubscriptionsVar, subscriptionsVar } from '@/graphql/state';
import { uniq } from 'lodash';

export const useSubscription = () =>
  useQuery<GetSubscriptionsResponse>(GET_SUBSCRIPTIONS, {
    fetchPolicy: 'cache-first',
    onCompleted(data) {
      if (data.subscriptions) {
        subscriptionsVar(uniq(data.subscriptions));
        allSubscriptionsVar(data.subscriptions);
      }
    },
  });

export const useLazySubscriptions = () =>
  useLazyQuery<GetSubscriptionsResponse>(GET_SUBSCRIPTIONS, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      if (data.subscriptions) {
        subscriptionsVar(uniq(data.subscriptions));
        allSubscriptionsVar(data.subscriptions);
      }
    },
  });
